export const SEND_WAITLIST_EMAIL = /* GraphQL */ `
  mutation sendWaitlistEmail($email: String!, $recaptchaToken: String!) {
    sendWaitlistEmail(email: $email, recaptchaToken: $recaptchaToken)
  }
`;
export default { SEND_WAITLIST_EMAIL };
